/**
 * Directive: ribon
 */
angular.module('acme.common.directive.ribon', [])
.directive('ribon', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/ribon/ribon.tpl.html',
      scope: {
        ribonMessage: '@',
        ribonDetails: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.ribon = "Your spankin new ribon!";

      }]

    };

}]);